





























































































































































































































































































































































































import Vue from "vue";

export default Vue.extend({
  name: "DiseaseEducation",
  data() {
    return {
      submitted: false,
      submitting: false,
      error: "",
      form: {
        name: "",
        email: "",
        country: "",
        role: "",
        message: "",
        age: false,
        privacy: false,
        consent: false,
        website: "",
        privacy_version: "v2026-08"
      }
    };
  },
  methods: {
    onSubmit() {
      this.submitting = true;
      this.error = "";
      fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(this.form)
      })
        .then((res) => {
          if (!res.ok) throw new Error("Server error");
          return res.json();
        })
        .then((data) => {
          if (data && data.ok) {
            this.submitted = true;
            this.form = {
              name: "",
              email: "",
              country: "",
              role: "",
              message: "",
              age: false,
              privacy: false,
              consent: false,
              website: "",
              privacy_version: "v2026-08"
            };
          } else {
            throw new Error((data && data.error) || "Submission failed");
          }
        })
        .catch((err) => {
          this.error =
            "Sorry, something went wrong. Please try again or contact us directly.";
          console.error(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
});
